<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat class="card-border">
          <h2>Виды реализации</h2>
          <v-dialog
            v-model="newSaletypeDialog"
            scrollable persistent modal
            width="640"
            transition="dialog-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon class="mx-3" color="secondary" v-on="on">
                <v-icon>
                  add
                </v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="subtitle-1">
                Добавление вида реализации
                <v-spacer></v-spacer>
                <v-btn icon small @click="dialogNewClose()"><v-icon>close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>
                <v-autocomplete
                  flat
                  label="Вид реализации"
                  :items="selectableSaletypes"
                  v-model="iSaletypeid"
                  no-data-text="Нет доступных видов реализации"
                  item-text="title" item-value="saletypeid"
                ></v-autocomplete>
              </v-card-text>
              <br /><br />
              <v-card-actions>
                <v-btn
                  color="primary"
                  :disabled="!iSaletypeid"
                  @click="linkSaletype()"
                >
                  Добавить
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text
                  @click="dialogNewClose()"
                >Отмена</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-spacer></v-spacer>

          <v-text-field
            v-model="search"
            append-icon="search"
            label="Поиск"
            single-line
            hide-details
            clearable
            style="max-width: 400px"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          class="card-border"
          no-data="пусто" no-data-text="пусто" no-results-text="ничего не найдено"
          :items-per-page="-1"
          :headers="headers"
          :items="orgsaletypes || []"
          :search="search"
          hide-default-footer dense
        >
        <template v-slot:item.action="{ item }">
          <v-btn class="px-1" color="red" x-small text @click="unlinkSaletype(item)">
            <v-icon small>delete</v-icon>
          </v-btn>
        </template>
        </v-data-table>
      </v-flex>
      <Confirmation></Confirmation>
    </v-layout>
  </v-container>
</template>

<script>
import Confirmation from '@/components/Confirmation'
export default {
  name: 'cafes',
  components: { Confirmation },
  data: () => ({
    orgsaletypes: [],
    saletypes: [],
    search: null,
    newSaletypeDialog: false,
    iSaletypeid: null,
    headers: [
      // { text: 'id', value: 'saletypeid' },
      { text: 'Вид реализации', value: 'title' },
      { text: 'Дата добавления', value: 'cts' },
      { text: 'Действия', value: 'action' },
    ]
  }),
  computed: {
    profile () {
      return this.$store.state.profile
    },
    orgid () {
      return this.$store.state.profile.orgid
    },
    selectableSaletypes () {
      return this.saletypes.filter(x => !this.orgsaletypes.map(os => os.saletypeid).includes(x.saletypeid))
    }
  },
  methods: {
    async fetch () {
      try {
        const { saletypes, meta } = await this.$store.dispatch('sioRequest', {
          topic: 'saletypes-by-orgid',
          pl: {
            orgid: this.orgid
          }
        })
        this.orgsaletypes = saletypes
        this.$store.dispatch('snack', meta.msg)
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async unlinkSaletype (item) {
      try {
        await this.$store.dispatch('confirm', `Прекратить использование типа продажи [${item.title}]?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'org-unlink-saletype',
          pl: {
            saletypeid: item.saletypeid
          }
        })
        this.$store.dispatch('snack', meta.msg)
        this.fetch()
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async linkSaletype () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'org-link-saletype',
          pl: {
            saletypeid: this.iSaletypeid
          }
        })
        this.$store.dispatch('snack', meta.msg)
        this.dialogNewClose()
        this.fetch()
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    dialogNewClose () {
      this.newSaletypeDialog = false
      this.saletypes = []
      this.iSaletypeid = null
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    },
    async newSaletypeDialog (val) {
      try {
        if (val) {
          const { saletypes } = await this.$store.dispatch('sioRequest', {
            topic: 'org-saletypes',
            pl: {}
          })
          this.saletypes = saletypes
        }
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    }
  },
  async mounted () {
    if (this.profile) await this.fetch()
  },
}
</script>
